import { useQuery } from "react-query";
import { namesUseQuery } from "../../utils/constants";
import { useContext } from "react";
import CurrentUserContext from "../../contexts/CurrentUserContext";
import { PersonService } from "../../services/PersonService";

export function usePersonByEmail() {
  const { userData } = useContext(CurrentUserContext);

  const { data, isLoading } = useQuery(
    [namesUseQuery?.PERSONS_BY_EMAIL],
    () => PersonService.itemsByUser(),
    {
      enabled: !!userData,
      onError: (error) => {
        console.log(error);
      },
    }
  );
  return {
    data,
    isLoading,
  };
}
